import { render, staticRenderFns } from "./AuditLogsList.vue?vue&type=template&id=0a514b70&scoped=true"
import script from "./AuditLogsList.vue?vue&type=script&lang=js"
export * from "./AuditLogsList.vue?vue&type=script&lang=js"
import style0 from "./AuditLogsList.vue?vue&type=style&index=0&id=0a514b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a514b70",
  null
  
)

export default component.exports